import './App.css';
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

import Index from "./pages/Index";
import Main from "./pages/Main";
import Faqs from "./pages/Faqs";
import Plans from "./pages/Plans";
import Advanced from "./pages/Advanced";
import Invoices from "./pages/Invoices";
import Inventory from "./pages/Inventory";
import Treasury from "./pages/Treasury";
import Accounting from "./pages/Accounting";
import Statements from "./pages/Statements";
import Register from "./pages/Register";
import Contact from "./pages/Contact";
import Error404 from "./pages/Error";
import ScrollToUp from './components/ScrollToUp';
import ReactPixel from 'react-facebook-pixel';
import { useEffect } from 'react';

const PIXEL_ID = '537137763981238';

function App() {  
  const location = useLocation();
  useEffect(() => {
    // 1. Inicializa el Pixel solo una vez al cargar la app
    const options = {
      autoConfig: true, 
      debug: false, 
    };
    ReactPixel.init(PIXEL_ID, undefined, options);
  }, []);
  
  useEffect(() => {      
      ReactPixel.pageView();
  }, [location]);

  return (
    <div className="App">             
        <ScrollToUp />              
          <Routes>              
            <Route path="/" element={<Index/>} />
            <Route path="/:isocode/" element={<Main/>} />
            <Route path="/:isocode/faq" element={<Faqs/>} />
            <Route path="/:isocode/plans" element={<Plans/>} />
            <Route path="/:isocode/advanced" element={<Advanced/>} />

            <Route path="/:isocode/invoice" element={<Invoices/>} />
            <Route path="/:isocode/inventory" element={<Inventory/>} />
            <Route path="/:isocode/treasury" element={<Treasury/>} />
            <Route path="/:isocode/accounting" element={<Accounting/>} />
            <Route path="/:isocode/statements" element={<Statements/>} />            

            <Route path="/:isocode/register/:id" element={<Register/>} />            
            <Route path="/:isocode/contact" element={<Contact/>} />            

            <Route path="*" element={<Error404 />} />
          </Routes>                 
    </div>
  );
}

export default App;
